// removed by extract-text-webpack-plugin
module.exports = {"video":"_1a542cc1","noVideo":"_90f768bf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/MobileVideo/VideoElement/styles.styl
// module id = 5167
// module chunks = 39